import React from "react";
import goldLogo from "../../assets/gold-logo.png";
import silverLogo from "../../assets/silverRateWork.png";

function CategoryBox({ setCategoryFilter, filters = {} }) {
  return (
    <div className="row mb-4">
      <div className="col-md-4">
        <div
          className={`category-box silver-box ${filters.category === "Silver" ? "active" : ""}`}
          onClick={() => {
            if (filters.category === "Silver") {
              setCategoryFilter({ ...filters, category: "" });
              return;
            }
            setCategoryFilter({ ...filters, category: "Silver" });
          }}
        >
          <div className="category-content">
            <img src={silverLogo} className="category-img" alt="Silver" />
            <h3>Silver</h3>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div
          className={`category-box gold-box ${filters.category === "Gold" ? "active" : ""}`}
          onClick={() => {
            if (filters.category === "Gold") {
              setCategoryFilter({ ...filters, category: "" });
              return;
            }
            setCategoryFilter({ ...filters, category: "Gold" });
          }}
        >
          <div className="category-content">
            <img src={goldLogo} className="category-img" alt="Gold" />
            <h3>Gold</h3>
          </div>
        </div>
      </div>
      <div className="col-md-4">
        <div
          className={`category-box others-box ${filters.category === "Others" ? "active" : ""}`}
          onClick={() => {
            if (filters.category === "Others") {
              setCategoryFilter({ ...filters, category: "" });
              return;
            }
            setCategoryFilter({ ...filters, category: "Others" });
          }}
        >
          <div className="category-content">
            <i className="fas fa-ellipsis" />
            <h3>Others</h3>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CategoryBox;
